import { Fragment, useContext } from 'react';
import { Context } from '../../context/UserContext';
import BarcodeScannerButton from './BarcodeScannerButton';
import styles from './DataList.module.css';

function DataList({
    text,
    name,
    handleOnChange,
    handleOnBlur,
    handleOnFocus,
    value,
    filteredOptions,
    inputWidth,
    title,
    readonly,
    placeholder,
    required,
    displayField = 'descricao',
    hidden = false,
    barcodeScanner = false,
}) {
    const { parametro } = useContext(Context);
    const Options = Array.isArray(filteredOptions) ? filteredOptions : [];

    // evita duplicar o mesmo value no datalist
    const seen = new Set();
    const push = (val) => {
        const s = String(val ?? '');
        if (!s || seen.has(s)) return false;
        seen.add(s);
        return true;
    };

    return (
        <div className={`${styles.form_control} ${styles[parametro.tema]}`}>
            <label htmlFor={name} title={title}>
                {hidden ? '' : `${text}:`}
            </label>

            {barcodeScanner && !hidden ? (
                <div className={styles.input_with_scanner} style={{ width: inputWidth || '100%' }}>
                    <input
                        className={styles.scanner_input}
                        type="text"
                        name={name}
                        list={name}
                        placeholder={placeholder}
                        onChange={handleOnChange}
                        onBlur={handleOnBlur}
                        onFocus={handleOnFocus}
                        value={value ?? ''}
                        readOnly={!!readonly}
                        required={required}
                        autoComplete="off"
                    />

                    <div className={styles.scanner_icon}>
                        <BarcodeScannerButton name={name} handleOnChange={handleOnChange} disabled={!!readonly} iconOnly />
                    </div>
                </div>
            ) : (
                <input
                    type="text"
                    name={name}
                    list={name}
                    placeholder={placeholder}
                    onChange={handleOnChange}
                    onBlur={handleOnBlur}
                    onFocus={handleOnFocus}
                    value={value ?? ''}
                    style={{ width: inputWidth || '100%', maxWidth: '100%' }}
                    readOnly={!!readonly}
                    required={required}
                    autoComplete="off"
                    hidden={hidden}
                />
            )}

            <datalist id={name} width={'100%'}>
                {Options.map((o) => (
                    <Fragment key={o.id}>
                        {/* principal: pela descrição */}
                        {push(o[displayField]) && (
                            <option
                                value={String(o[displayField] ?? '')}
                                data-id={o.id}
                                data-descricao={o.descricao ?? ''}
                                label={o.label ?? ''}
                                //data-codigo={o.codigo ?? ""}
                                //data-cb={o.codigoBarras ?? ""}
                                //label={"cod. barras: " + o.codigoBarras ?? ""}
                            />
                        )}
                    </Fragment>
                ))}
            </datalist>
        </div>
    );
}

export default DataList;
